import { render } from "./discover.vue?vue&type=template&id=42539728"
import script from "./discover.vue?vue&type=script&lang=js"
export * from "./discover.vue?vue&type=script&lang=js"

import "./discover.vue?vue&type=style&index=0&id=42539728&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__